"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Radio.css");

function Radio(props) {
  var className = props.className,
      checked = props.checked,
      disabled = props.disabled,
      messageType = props.messageType,
      value = props.value,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "checked", "disabled", "messageType", "value"]);
  var classNames = (0, _classnames["default"])(['stx-radio', {
    'stx-radio--is-disabled': disabled
  }, {
    'stx-radio--is-checked': checked
  }, {
    'stx-radio--alert': messageType === 'alert' || messageType === 'error'
  }, {
    'stx-radio--warning': messageType === 'warning'
  }, {
    'stx-radio--success': messageType === 'success'
  }, className]);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: classNames
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, otherProps, {
    role: "radio",
    type: "radio",
    value: value,
    className: "stx-radio__input",
    checked: checked,
    disabled: disabled,
    "aria-checked": checked,
    "aria-disabled": disabled
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "stx-radio__box"
  }));
}

Radio.defaultProps = {};
Radio.propTypes = {
  /** Optional className for the chekcbox component */
  className: _propTypes["default"].string,

  /** Whether or not the radio component is checked */
  checked: _propTypes["default"].bool,

  /** Whether or not the radio component is disabled */
  disabled: _propTypes["default"].bool,

  /** The type of message to display */
  messageType: _propTypes["default"].oneOf(['success', 'warning', 'alert', '']),

  /** The value of the radio component */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = Radio;
exports["default"] = _default;